// This import loads the firebase namespace along with all its type information.
import GameArtifact from './game-artifact-model'

export async function load_gameArtifacts(): Promise<GameArtifact[]> {
  throw 'Not implemented'
}

export async function delete_gameArtifact(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_gameArtifact(): Promise<GameArtifact> {
  throw 'Not implemented'
}
